"use strict";

exports.templates = {
  StackDebugParamsTemplate: "%s\n\n%s%s",
  AppendToTemplate: "%s\n\n%s\n\n%s"
};

exports.StackTraceDelimiter = "     ------------------------- FROM -------------------------";
exports.DebugPrefix = "Debug Params: ";
